import { FormFieldSettingsFields } from "components/Forms/FormFieldSettingsForm/FormFieldSettingsFields";
import { FormFieldsFormData } from "components/Forms/FormFieldsForm/formSchema";
import { Drawer } from "components/UI/Drawer";
import { DrawerTitle } from "components/UI/DrawerTitle/DrawerTitle";
import { useGeneralForm } from "components/UI/GeneralForm/hooks/useGeneralForm";
import { usePaldockTranslation } from "hooks/usePaldockTranslation";
import { useWatch } from "react-hook-form";
import { FormFieldTypes } from "types/enums";
import { DrawerId } from "types/models";

interface LocalFieldSettingsDrawerProps {
    formFieldId: string;
}

export const LocalFieldSettingsDrawer = ({ formFieldId }: LocalFieldSettingsDrawerProps) => {
    const id = DrawerId.LocalFieldSettings;
    const { t } = usePaldockTranslation("forms.form-field-settings");
    const { control } = useGeneralForm();
    const formFields = (useWatch({ control, name: "formFields" }) || []) as FormFieldsFormData[];
    const index = formFields.findIndex((field) => field.id === formFieldId);
    const field = formFields[index];

    if (!field) return null;

    return (
        <Drawer
            drawerId={id}
            title={
                <DrawerTitle mainTitle={t("title", { fieldName: field.visible_description || field.system_name })} />
            }
            searchParamsToClean={[`${id}-formFieldId`]}
        >
            <FormFieldSettingsFields
                type={(field.type || FormFieldTypes.Text) as FormFieldTypes}
                propertyPath={`formFields.${index}`}
            />
        </Drawer>
    );
};
